import { useRef, useState } from 'react';
import { createCommandKeyStore } from '../utilities/idempotency';
import { paymentErrorStatus } from '../utilities/paymentErrors';
const definiteRefusal = error => {
  const body = error?.response?.data;
  const codes = [error?.code, body?.code, body?.error?.code, body?.data?.code];
  if (codes.some(code => typeof code === 'string' && (code === 'PAYMENT_LINK_SEND_UNCERTAIN' || code.endsWith('_RECONCILIATION_REQUIRED')))) return false;
  return !!error?.response && [400, 403, 404, 409, 422].includes(paymentErrorStatus(error));
};
export function usePaymentCommand(prefix, onSuccess) {
  const keys = useRef(createCommandKeyStore(prefix));
  const frozen = useRef(null);
  const frozenCommand = useRef(null);
  const inFlight = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);
  const submit = async (command, payload) => {
    if (inFlight.current || result) return null;
    if (!frozen.current) { frozen.current = { ...payload, idempotency_key: keys.current.get() }; frozenCommand.current = command; }
    inFlight.current = true; setBusy(true); setError(null);
    try { const next = await frozenCommand.current(frozen.current); setResult(next); await onSuccess?.(next); return next; }
    catch (next) {
      if (definiteRefusal(next)) { frozen.current = null; frozenCommand.current = null; keys.current.clear(); }
      setError(next); return null;
    }
    finally { inFlight.current = false; setBusy(false); }
  };
  return { busy, error, result, submit, frozen: !!frozen.current };
}
